import { render, staticRenderFns } from "./Personales.vue?vue&type=template&id=05462882&lang=html&"
import script from "./Personales.vue?vue&type=script&lang=js&"
export * from "./Personales.vue?vue&type=script&lang=js&"
import style0 from "./Personales.vue?vue&type=style&index=0&id=05462882&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports